var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatCenter = function SvgChatCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_radial_4898_10951)",
    d: "M15.8571 1H8.14286C4.19797 1 1 4.19797 1 8.14286V15.8571C1 19.802 4.19797 23 8.14286 23H15.8571C19.802 23 23 19.802 23 15.8571V8.14286C23 4.19797 19.802 1 15.8571 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "evenodd",
    d: "M9.70114 5.35556C13.2591 3.719 15.9067 3.54585 17.56 4.93665C20.4869 7.40546 19.2524 10.8797 18.1186 13.9405C17.2026 16.3759 16.2474 17.8671 15.2979 18.772C13.7451 20.269 12.5107 20.336 11.5611 20.269C9.55593 20.1684 7.93611 19.0569 6.13757 16.482C4.59037 14.2924 3.32246 11.9633 4.48424 9.35482C4.66298 8.9359 5.40027 7.33843 9.70114 5.35556ZM14.7828 13.0305C13.4157 16.8373 12.4301 16.7514 11.661 16.6844L11.6493 16.6834C10.912 16.6164 9.996 15.8847 8.97384 14.4213C7.49368 12.2653 7.56628 11.6397 7.91818 10.8074C8.16394 10.2154 9.04646 9.6233 11.2304 8.5844C13.6992 7.40026 14.7158 7.61252 15.1068 7.89179C16.0173 8.57882 16.0173 9.5842 14.7828 13.0305Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4898_10951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(12 12) rotate(90) scale(11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#8C23C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C335C2"
  })))));
};
export default SvgChatCenter;